import { render, staticRenderFns } from "./RegisterAddOrEdit.vue?vue&type=template&id=740092c2&"
import script from "./RegisterAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./RegisterAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAddOrEdit.vue?vue&type=style&index=0&id=740092c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports